/**
 * @generated SignedSource<<b73dfda2e55d7cd22fe1a5210c54585c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type colorPaletteSettings_deletePaletteMutation$variables = {
  id: string;
};
export type colorPaletteSettings_deletePaletteMutation$data = {
  readonly deletePalette: {
    readonly palette: {
      readonly id: string;
      readonly name: string;
    } | null;
  };
};
export type colorPaletteSettings_deletePaletteMutation = {
  response: colorPaletteSettings_deletePaletteMutation$data;
  variables: colorPaletteSettings_deletePaletteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PaletteOutput",
    "kind": "LinkedField",
    "name": "deletePalette",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Palette",
        "kind": "LinkedField",
        "name": "palette",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "colorPaletteSettings_deletePaletteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "colorPaletteSettings_deletePaletteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7bb7445e68ae22889f15df8d920afe11",
    "id": null,
    "metadata": {},
    "name": "colorPaletteSettings_deletePaletteMutation",
    "operationKind": "mutation",
    "text": "mutation colorPaletteSettings_deletePaletteMutation(\n  $id: ID!\n) {\n  deletePalette(id: $id) {\n    palette {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "937bb74ceaa3565f8fb337e6df0ad738";

export default node;
